import store  from '@/utils/store'
import {deviceName} from '@/utils/util'
export const columns = (vm) =>{
    return [
        {
          type: 'selection',
          width: 50,
        },
          {
            prop: 'serialNo',
            label: '设备信号',
            align: "center",
            headerAlign: "center",
            minWidth: 160,
            render: (h, params) => {
              let info = JSON.parse(params.row.extend)
              let Imgsrl = ""
              if (!!info && params.row.status*1==1) {
      
                if (info.signalNumber == 0 || !info.signalNumber) {
                  Imgsrl = require("@/assets/custom-icon/sign.svg")
                } else if (1 <= info.signalNumber && info.signalNumber <= 30) {
                  Imgsrl = require("@/assets/custom-icon/signA.svg")
                } else if (30 < info.signalNumber && info.signalNumber <= 50) {
                  Imgsrl = require("@/assets/custom-icon/signB.svg")
                } else if (50 < info.signalNumber && info.signalNumber <= 70) {
                  Imgsrl = require("@/assets/custom-icon/signC.svg")
                } else if (70 < info.signalNumber && info.signalNumber <= 90) {
                  Imgsrl = require("@/assets/custom-icon/signD.svg")
                } else if (90 < info.signalNumber && info.signalNumber <= 100) {
                  Imgsrl = require("@/assets/custom-icon/signE.svg")
                }
              } else {
                Imgsrl = require("@/assets/custom-icon/wu.svg")
              }
              let wu = (h) => {
                return h('el-image', {
                  props: {
                    lazy: true,
                    src: Imgsrl,
                  },
                  style: {
                    width: "26px",
                    height: "26px",
                    position: "relative",
                    top: "5px"
                  }
                })
              }
              return h('div', { class: "common-items-center,common-space-around" }, [wu(h)])
            }
      
          },
          {
            prop: 'extend',
            label: '物模型',
            width: 260,
            render: (h, params) => {
              let textKu = store.state.conText.modelList
              let info = JSON.parse(params.row.extend)
              let text = ""
              if (!!info) {
                textKu.forEach(res => {
                  if (res.code == params.row.deviceTypeCode) {
                    let list = res.list
                    for (var i in info) {
                      for (var j in list) {
                        if (list[j].title == i) {
                          
                          if (res.code == "gmt" && list[j].title == "status") {                   //门磁
                            text = text + `${list[j].val}：${info[i] == 1 ? "开门" : "关门"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
      
                          } else if (res.code == "dgat" && list[j].title == "policeStatus") {     //家用燃气
                            text = text + `${list[j].val}：${info[i] ? "报警" : "正常"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
      
                          } else if (res.code == "lgat" && list[j].title == "policeStatus") {     //工业燃气 
                            text = text + `${list[j].val}：${info[i] ? "报警" : "正常"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
                          }else if (res.code == "gahft" && list[j].title == "switchStatus") {     //工业4G主机
                            text = text + `${list[j].val}：${info[i] ? "闭合" : "断开"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
      
                          }else if (res.code == "sscdt" && list[j].title == "switchStatus") {     //烟感复合探测器物模型
                            text = text + `${list[j].val}：${info[i] ? "闭合" : "断开"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
      
                          }else if (res.code == "sdt" && list[j].title == "policeStatus") {     //烟感复合探测器物模型
                            text = text + `${list[j].val}：${info[i] ? "报警" : "正常"}${!list[j].unit ? "" : list[j].unit}<br/>`
      
                          } else {
                            text = text + `${list[j].val}：${info[i]}${!list[j].unit ? "" : list[j].unit}<br/>`
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                text = "--"
              }
              return h('div', { domProps: { innerHTML: text } });
            }
          },
          {
            prop: 'deviceName',
            label: '设备信息',
            width: 220,
            render: (h, params) => {
              let text = ""
              text = text + `设备名称：${deviceName(params.row.deviceName)}<br/><div  class="common-flex"><div style="">IMEI：</div><div class="common-flexw">${params.row.serialNo}`
              return h('div', { domProps: { innerHTML: text } });
            }
          },
          {
            prop: 'projectName',
            label: '安装信息',
            width: 360,
            render: (h, params) => {
              let text = ""
              if(!!params.row.projectName){
                  text = text+`项目名称：${params.row.projectName}<br/><div  class="common-flex"><div style="width:60px">安装位置：</div><div class="common-flexw">${params.row.address}</div></div>安装时间：${params.row.bindingTime}<br/>安装人员：${params.row.installerName}-${params.row.installerPhone}`
              }else{
                text = "--"
              } 
              return h('div',{domProps:{innerHTML: params.row.hasBingding ? text : "--"}});
            }
          },
          {
            prop: 'statusChangeTime',
            label: '在线离线时间',
            width: 170,
          },
          {
            prop: 'enabled',
            label: '设备状态',
            width: 100,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
              let list = store.state.conText.stateList
              let text = ""
              let color = ""
              for(var i in list){
                 if(list[i].val == params.row.enabled){
                    text =  list[i].title
                    color = list[i].color
                 }
              }
              return h('span', {style:{color:color}}, text);
            }
          },
          {
            prop: 'hasBingding',
            label: '是否安装',
            align:"center",
            headerAlign:"center",
            width: 100,
            render: (h, params) => {
              let text = params.row.hasBingding ? "已安装":"未安装"
              let color = params.row.hasBingding ? "#07C160":"#B4B4B4"
              return h('span', {style:{color:color}}, text);
            }
          },
          {
            prop: 'status',
            label: '在线状态',
            align:"center",
            headerAlign:"center",
            width: 100,
            render: (h, params) => {
              let text = params.row.status==1 ? "在线":"离线"
              let color = params.row.status==1 ? "#07C160":"#B4B4B4"
              return h('span', {style:{color:color}}, text);
            }
          },
          {
            prop: 'warnStatus',
            label: '报警状态',
            align:"center",
            headerAlign:"center",
            width: 100,
            render: (h, params) => {
              let IMGBLOCK = (h) => {
                return h('el-image', {
                  props: {
                    lazy: true,
                    src: require("@/assets/custom-icon/alarm.gif"),
                    previewSrcList: [require("@/assets/custom-icon/alarm.gif")]
                  },
                  style: {
                    width: "35px",
                    height: "35px",
                    borderRadius: "4px",
                    position: "relative",
                    top: "5px"
                  }
                })
              }
              return h('div', { class: "common-items-center,common-space-around", style: { color: "#07C160" } }, params.row.warnStatus == 1 ? "正常" : [IMGBLOCK(h)])
            }
          },
          {
            prop: 'expirationTime',
            label: '过期时间',
            width: 170,
            tooltip: true,
            render: (h, params) => {
                      let timeA = 0
                      let timeB = 0
                      let mark = true
                     if(!!params.row.expirationTime){
                           timeA =  (new Date(params.row.expirationTime)).getTime()
                           timeB =  new Date().getTime()*1
                           mark = timeA >  timeB ? true:false
                     }else{
                        mark = false
                     }
                     return h('span', { style:{color:mark ? "":"#E2282B"} }, !!params.row.expirationTime ? params.row.expirationTime:'--');
                  }
          },
          {
            prop: 'createTime',
            label: '创建时间',
            width: 170,
          },

    ]
}